var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox',{staticClass:"mb-4",model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_vm._v(" メールアドレスとパスワードを保存する ")])}
var staticRenderFns = []

export { render, staticRenderFns }